import { __spreadArray } from 'tslib';
import * as React from 'react';
import { useRef, useEffect } from 'react';
import { UitkLineSkeleton } from 'uitk-react-skeleton';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-date-range.css';
import { applyFade } from './utils.esm.js';
import { UitkDateRangeGetSelectedDateScrollCenterDistance } from './uitk-date-range-util-functions.esm.js';
import { UitkDateRangeButton } from './uitk-date-range-button.esm.js';
var getClassNameList = classNames.bind(styles);
var UitkDateRange = function (_a) {
  var loading = _a.loading,
    loadingMessage = _a.loadingMessage,
    results = _a.results;
  var baseClassName = 'uitk-date-range';
  var buttonClassName = "".concat(baseClassName, "-button");
  var scrollMouse = {
    move: false,
    initialMousePos: 0,
    buttonLeft: 0
  };
  var dateRangeRef = useRef(null);
  var getSelectedDateResultsIndex = function () {
    return results.findIndex(function (resultObj) {
      return resultObj.selected;
    });
  };
  var selectedDateIndex = getSelectedDateResultsIndex();
  var buttonScroll = function (parent) {
    if (parent.currentTarget) {
      applyFade(parent.currentTarget);
    }
  };
  var resizeTimeout;
  var mouseDown = function (ev) {
    scrollMouse.move = true;
    scrollMouse.initialMousePos = ev.clientX;
    scrollMouse.buttonLeft = ev.currentTarget.scrollLeft;
  };
  var mouseUp = function () {
    scrollMouse.move = false;
  };
  var mouseMove = function (ev) {
    if (scrollMouse.move) {
      // eslint-disable-next-line no-param-reassign
      ev.currentTarget.scrollLeft = scrollMouse.buttonLeft + scrollMouse.initialMousePos - ev.clientX;
      buttonScroll(ev);
    }
  };
  var onWindowResize = function () {
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(function () {
        var dateRangeEl = dateRangeRef && dateRangeRef.current;
        var selectedDateScrollCenterDistance = UitkDateRangeGetSelectedDateScrollCenterDistance(dateRangeEl, selectedDateIndex);
        dateRangeEl && (dateRangeEl.scrollLeft = selectedDateScrollCenterDistance);
        resizeTimeout = null;
        applyFade(dateRangeRef.current);
      }, 200);
    }
  };
  useEffect(function () {
    var dateRangeEl = dateRangeRef && dateRangeRef.current;
    var selectedDateScrollCenterDistance = UitkDateRangeGetSelectedDateScrollCenterDistance(dateRangeEl, selectedDateIndex);
    dateRangeEl && (dateRangeEl.scrollLeft = selectedDateScrollCenterDistance);
    applyFade(dateRangeRef.current);
    window.addEventListener('resize', onWindowResize);
    return function () {
      window.removeEventListener('resize', onWindowResize);
    };
  }, []);
  return React.createElement("div", {
    className: getClassNameList("".concat(baseClassName, "-container"))
  }, loading && loadingMessage && React.createElement("span", {
    className: "is-visually-hidden"
  }, loadingMessage), React.createElement("ul", {
    ref: dateRangeRef,
    role: "tablist",
    className: getClassNameList(baseClassName),
    onScroll: buttonScroll,
    onMouseDown: mouseDown,
    onMouseUp: mouseUp,
    onMouseMove: mouseMove,
    onMouseLeave: mouseUp
  }, !loading && results.map(function (result, index) {
    var buttonName = "".concat(buttonClassName, "-").concat(index);
    return React.createElement("li", {
      className: getClassNameList("".concat(baseClassName, "-button-wrapper-natural")),
      role: "presentation",
      key: buttonName
    }, React.createElement(UitkDateRangeButton, {
      className: getClassNameList(buttonClassName),
      result: result
    }));
  }), loading && __spreadArray([], Array(7), true).map(function (_, index) {
    return React.createElement("li", {
      className: getClassNameList('uitk-date-range-loading-cell'),
      key: "uitk-date-range-loading-cell-".concat(index),
      role: "tab"
    }, React.createElement(UitkLineSkeleton, null));
  })));
};
export { UitkDateRange };